export const EVENT_REPORT = `
	query attendance($event_id: Uint) {
		attendance(event_id: $event_id) {
			logged_in
			total
			percent_of_total
		}
	}
`;
